export default __webpack_public_path__ + "static/media/ActiveGroup.7d6f32de.svg";